export default {
  claimXvsRewardButton: 'layout-claim-xvs-reward-button',
};
